import React from "react";

// Mapping des tailles nommées → hauteur en px (compatibilité rétro pour les
// anciens call sites qui passaient "sm"/"md"/"lg")
const SIZE_MAP = { sm: 28, md: 40, lg: 56, xl: 72 };

// Logo officiel Biz360 (pilule violette + typographie crème + cœur enflammé)
// Aspect ratio ~3.04:1 (1223×403). `size` accepte un nombre (px) ou une clé
// nommée ("sm"|"md"|"lg"|"xl").
export const Biz360Logo = ({ size = 40, className = "", ...rest }) => {
  const px = typeof size === "number" ? size : (SIZE_MAP[size] || 40);
  return (
    <img
      src="/branding/biz360-logo.png"
      alt="Biz360"
      height={px}
      style={{ height: px, width: "auto", display: "inline-block" }}
      className={className}
      data-testid="biz360-logo"
      {...rest}
    />
  );
};
